import debug from 'debug';
import InspirationProducts from '../inspiration-products/inspiration-products';
import ProductsByCategory from './data/productsByCategory';
import Render from './render/render';

const log = debug('InspirationProductsByCategory');

class InspirationProductsByCategory extends InspirationProducts {
	constructor(element) {
		super(element);
	}

	async getProducts() {
		if (this.products !== undefined) return this.products;

		if (this.isFollowingRuns === true) return [];
		this.isFollowingRuns = true;

		const productsByCategory = new ProductsByCategory();
		const products = await productsByCategory.get({
			categories: this.settings.categories,
			excludeBorderShops: this.settings.excludeBorderShops === 'True' ? true : false,
			numberOfResults: this.settings.numberOfResults
		});
		log('getProducts()', products);
		this.products = products;

		return products;
	}

	ready() {
		if (this.render !== undefined) return;
		this.render = new Render(this.dom.list, this.products);
	}
}

export default InspirationProductsByCategory;
